<script lang="ts">
import FicheContrat from '@/generated/fiches/FicheContrat.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheContrat
})

</script>
